import { make } from 'vuex-pathify'
import dottie from 'dottie'
import LunrWrapper from '@/LunrWrapper'
import { utils, writeFile } from 'xlsx'
import { api } from '@/api'

const exportToFile = (filename, rows) => {
  const ws = utils.json_to_sheet(rows)
  const wb = utils.book_new()
  utils.book_append_sheet(wb, ws)
  writeFile(wb, filename)
}

/**
 * Function to sort alphabetically an array of objects by some specific key.
 *
 * @param {String} property Key of the object to sort.
 */
function dynamicSort(property) {
  var sortOrder = 1

  if (property[0] === '-') {
    sortOrder = -1
    property = property.substr(1)
  }

  return function(a, b) {
    const num = Number.isInteger(a[property]) && Number.isInteger(b[property])
    if (sortOrder === -1) {
      if (num) return b[property] - a[property]
      return b[property].localeCompare(a[property])
    } else {
      if (num) return a[property] - b[property]
      return a[property].localeCompare(b[property])
    }
  }
}

const state = {
  firms: [],
  sortKey: 'name',
  sortOrder: 'ascend',
  searchTerm: '',
  lunr: null
}

const getters = {
  ...make.getters(state),

  sortedList(state, getters) {
    const sortProperty =
      state.sortOrder === 'ascend' ? state.sortKey : `-${state.sortKey}`
    return getters.filteredList.sort(dynamicSort(sortProperty))
  },

  filteredList: state =>
    state.lunr ? state.lunr.query(state.searchTerm) : state.firms,

  firmsExport(state, getters) {
    return getters.sortedList.map(r => {
      return {
        Firma: r.name,
        Straße: r.street,
        PLZ: r.zip,
        Ort: r.city
      }
    })
  }
}

const mutations = {
  ...make.mutations(state),
  read(state, firms) {
    state.firms = firms
    state.lunr = new LunrWrapper(firms, ['name', 'street', 'zip', 'city'])
  }
}

const actions = {
  async list({ commit }) {
    try {
      const response = await api.get('/firms')
      const firms = dottie.get(response, 'data.firms', [])
      commit('read', firms)
    } catch (e) {
      commit('SET_FIRMS', [])
    }
  },

  exportXlsx({ getters }) {
    exportToFile('Export.xlsx', getters.firmsExport)
  },

  exportCsv({ getters }) {
    exportToFile('Export.csv', getters.firmsExport)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
